import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ngxui-taskbar-tabs-right',
  templateUrl: './taskbar-tabs-right.component.html',
  styleUrls: ['./taskbar-tabs-right.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TaskbarTabsRightComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
